import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext.js';
import AccountantCompanySettlementApprovals from './AccountantCompanySettlementApprovals.js';

/** Each agent settles on their own page. Hub Admin does not remit for them. */
export default function CompanySettlementRoleGate() {
  const { user } = useAuth();
  if (user?.role === 'Hub Admin') {
    return <Navigate to="/admin-dashboard" replace />;
  }
  return <AccountantCompanySettlementApprovals />;
}

export function MlSettlementApprovalsGate() {
  const { user } = useAuth();
  if (user?.role === 'Hub Admin') {
    return <Navigate to="/admin-dashboard" replace />;
  }
  return <Navigate to="/company-settlement-approvals" replace />;
}
